const methods = [
  'интервью с руководителем;',
  'интервью с собственником или вышестоящим руководителем;',
  'анализ типичных управленческих ситуаций;',
  'обратная связь от сотрудников;',
  'оценка управленческих компетенций;',
  'анализ повторяющихся проблем;',
  'наблюдение за совещаниями и коммуникациями;',
  'разбор реальных кейсов;',
  'анализ показателей подразделения.',
];

export default function DiagnosisZones() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          С чего начинать развитие управленческих компетенций
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Прежде чем учить, важно понять зоны развития конкретного руководителя. Для диагностики используются разные способы:
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto mb-12">
          {methods.map((m, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-search-eye-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{m}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center mb-10">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Конкретный набор диагностических инструментов определяется задачей компании.
          </p>
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить диагностику управленческих компетенций
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}